export default __webpack_public_path__ + "static/media/poison.3d627ffc.png";